(function () {
  'use strict';

  var hero = document.querySelector('.hero');
  if (!hero) return;

  var speed = 0.3;
  var ticking = false;

  function updateParallax() {
    var scrolled = window.pageYOffset || document.documentElement.scrollTop;
    hero.style.setProperty('--parallax-y', (scrolled * speed) + 'px');
    ticking = false;
  }

  updateParallax();

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }, { passive: true });

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (prefersReduced.matches) {
    speed = 0;
  }
})();
